/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-procedure-item.reducer';

export const HospitalProcedureItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalProcedureItemEntity = useAppSelector(state => state.hospitalProcedureItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalProcedureItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.detail.title">HospitalProcedureItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureItemEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.holder">Holder</Translate>
          </dt>
          <dd>{hospitalProcedureItemEntity.holder ? hospitalProcedureItemEntity.holder.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalProcedureItem.item">Item</Translate>
          </dt>
          <dd>{hospitalProcedureItemEntity.item ? hospitalProcedureItemEntity.item.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-procedure-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-procedure-item/${hospitalProcedureItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalProcedureItemDetail;
